import logo from "../images/logo.jpg";

export default function Crewlist() {
  function crew() {
    return (
      <a href="#" className="card2">
        <div className="pic">
          <img src={logo} alt="" />
        </div>
        <p className="bio">
          Lorem ipsum dolor sit amet consectetur, adipisicing elit.
          Exercitationem, inventore! Illo quisquam repellendus vero eum alias
          velit praesentium harum voluptate adipisci quasi similique, unde quia
          tempora modi nemo repellat soluta.
        </p>
      </a>
    );
  }
  return (
    <div>
      <div className="title">Our Crew</div>
      <div className="crew">
        {crew()}
        {crew()}
        {crew()}
        {crew()}
        {crew()}
        {crew()}
        {crew()}
      </div>
    </div>
  );
}
